import { render } from "./TrasfusionsTab.vue?vue&type=template&id=5c19cfbc"
import script from "./TrasfusionsTab.vue?vue&type=script&lang=js"
export * from "./TrasfusionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__